/** @file retargetEntry: the facet.setTable rule, one entry moved onto another sector table. */
import { tileCountOf } from '@zilo/pose3d-format/tables/tileCountOf';
import type { FacetEntry, SectorTable } from '@zilo/pose3d-format/types/facet';
import type { DrawnAngles } from '../types/puppetInputs';
import { checkAngleCount } from './checkAngleCount';

const ANGLE_KEYS = ['drawnAzimuths', 'drawnScreenAngles'] as const;

/**
 * Points `entry.yaw` at `table` and returns its tile count: given drawn angles replace the entry's, and every drawn
 * angle array (given or kept) must have one value per tile (`DRAWN_ANGLES_LENGTH` at `<path>/<key>`); slot images of
 * tiles the table lacks are dropped. Edits `entry` in place, after the checks.
 */
export function retargetEntry(entry: FacetEntry, table: SectorTable, angles: DrawnAngles, path = '/input'): number {
  const tiles = tileCountOf(table);
  for (const k of ANGLE_KEYS) checkAngleCount(angles[k] ?? entry[k], tiles, `${path}/${k}`);
  entry.yaw = table.id;
  for (const k of ANGLE_KEYS) { const v = angles[k]; if (v !== undefined) entry[k] = [...v]; }
  entry.slots = Object.fromEntries(Object.entries(entry.slots).filter(([t]) => Number(t) < tiles));
  return tiles;
}
